<mat-progress-bar
	[bufferValue]="PROGRESSBAR.BUFFER_VALUE"
	[color]="PROGRESSBAR.COLOR"
	[mode]="PROGRESSBAR.MODE"
	[value]="PROGRESSBAR.VALUE"
>
</mat-progress-bar>
